import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';

import { regulatoryFilters } from '@/constants/filters/PositionTrainingMatrixFilter';
import { TrainingTypeEnum } from '@/constants/trainingTypeOptions';
import {
	PositionTrainingMatrixFilters,
	positionTrainingMatrixFiltersAtom,
} from '@/state/PositionTrainingMatrixFilter.atom';

import SideFilter from './SideFilter';

interface RegulatoryTrainingFilterSectionProps {
	setFilteredData: React.Dispatch<
		React.SetStateAction<PositionTrainingMatrixFilters>
	>;
	fetchIndicators: (filters: PositionTrainingMatrixFilters) => Promise<void>;
}

export const RegulatoryTrainingFilterSection = ({
	fetchIndicators,
	setFilteredData,
}: RegulatoryTrainingFilterSectionProps) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [filterValues, setFilteredValues] = useRecoilState(
		positionTrainingMatrixFiltersAtom,
	);

	const handleApplyFilter = (isReseting: boolean) => {
		if (isReseting)
			setFilteredData(() => ({
				trainingType: [TrainingTypeEnum.REGULATORY],
				location: [],
				position: [],
				training: [],
				management: [],
				areaCoordination: [],
				workstation: [],
			}));
		else {
			setFilteredData(() => ({
				...filterValues,
			}));
			fetchIndicators(filterValues);
		}
	};

	useEffect(() => {
		const trainingType = searchParams.get('tipo');
		const location = searchParams.get('polo');
		const training = searchParams.get('treinamento');
		const position = searchParams.get('funcao');

		setFilteredValues((prev) => ({
			...prev,
			trainingType: trainingType ? [trainingType] : prev.trainingType,
			location: location ? [location] : prev.location,
			training: training ? [training] : prev.training,
			position: position ? [position] : prev.position,
		}));

		setFilteredData((prev) => ({
			...prev,
			trainingType: trainingType ? [trainingType] : prev.trainingType,
			location: location ? [location] : prev.location,
			training: training ? [training] : prev.training,
			position: position ? [position] : prev.position,
		}));

		searchParams.delete('tipo');
		searchParams.delete('polo');
		searchParams.delete('treinamento');
		searchParams.delete('funcao');
		setSearchParams(searchParams);
	}, []);

	return (
		<SideFilter
			refetchOnChange
			filters={regulatoryFilters}
			atom={positionTrainingMatrixFiltersAtom}
			applyChanges={handleApplyFilter}
			disabled={filterValues.location.length === 0}
		/>
	);
};
